<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    class="icon-svg icon-search"
  >
    <path
      fill-rule="evenodd"
      d="M22.344 23c-.175 0-.34-.068-.464-.192l-5.7-5.7c-.665.569-1.415 1.033-2.233 1.38-1.075.457-2.205.69-3.357.69-1.1 0-2.18-.212-3.213-.629-2.127-.858-3.792-2.492-4.688-4.603-.897-2.11-.919-4.444-.06-6.57.858-2.125 2.492-3.79 4.602-4.688C8.306 2.231 9.435 2 10.588 2c1.1 0 2.18.212 3.213.628 2.127.858 3.792 2.492 4.688 4.603.897 2.111.919 4.444.06 6.57-.351.871-.836 1.67-1.442 2.377l5.701 5.702c.256.256.256.672 0 .928-.124.124-.29.192-.464.192zM10.588 3.312c-.976 0-1.933.196-2.844.584-1.788.76-3.173 2.17-3.9 3.971-.727 1.801-.708 3.777.051 5.566.76 1.788 2.17 3.172 3.972 3.9.876.353 1.792.531 2.722.531.976 0 1.933-.196 2.844-.583.852-.362 1.616-.873 2.269-1.519.009-.012.018-.023.028-.032.014-.014.027-.026.04-.034.667-.675 1.197-1.481 1.562-2.387.727-1.801.708-3.777-.052-5.565-.76-1.788-2.17-3.173-3.972-3.9-.874-.352-1.79-.532-2.72-.532z"
    />
  </svg>
</template>
